import React, {Component} from 'react';
import {Modal, Button} from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from "prop-types";
import PersonDetail from "../../../../components/PersonDetail";
import {connect} from "react-redux";


class PersonDetailModal extends Component {
    static contextTypes = {api: PropTypes.object};

    constructor(props, context) {
        super(props);

        if (props.person) {
            context.api.people.getById(props.person.id, "currentPerson").then((data) => {
            })
        }

        context.api.specialties.get(0, 200);
        this.context = context;

    }


    render() {
        return (
            <Modal
                show={true}
                onHide={this.props.onHide}
                className='PersonDetailModal'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Detalles del miembro</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    {this.props.currentPerson !== undefined && this.props.currentPerson !== null ?
                        <PersonDetail
                            onAnyChange={this.props.onAnyChange}
                            person={this.props.currentPerson}
                            canEdit={this.props.canEdit}
                            canDownloadCredential={this.props.canDownloadCredential}
                        /> :
                        <h1>Cargando...</h1>
                    }


                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='danger' onClick={this.props.onHide}>Cerrar</Button>
                </Modal.Footer>

            </Modal>
        );
    }
}

const mapStateToProps = ({ api: { currentPerson = null }}) => {
    return {currentPerson};
};

export default connect(mapStateToProps)(PersonDetailModal);




// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/People/components/PersonDetailModal/index.js